import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { Button } from '../components/ui/Button';
import { LogIn, AlertCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export const LoginPage: React.FC = () => {
  const location = useLocation();
  const { user, signInWithGoogle, isLoading, error, clearError } = useAuthStore();
  const from = (location.state as any)?.from || '/';

  useEffect(() => {
    clearError();
  }, [clearError]);

  // If already logged in, redirect
  if (user) {
    return <Navigate to={from} replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-red-50 to-white flex items-center justify-center px-4">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <h2 className="mt-6 text-3xl font-bold text-gray-900">Welcome Back! 🎅</h2>
          <p className="mt-2 text-sm text-gray-600">
            Sign in to access your magical Santa videos
          </p>
        </div>

        <AnimatePresence>
          {error && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="bg-red-50 text-red-600 p-4 rounded-lg flex items-center"
            >
              <AlertCircle className="w-5 h-5 mr-2 flex-shrink-0" />
              <p className="text-sm">{error}</p>
            </motion.div>
          )}
        </AnimatePresence>

        <div className="mt-8">
          <Button
            onClick={signInWithGoogle}
            variant="primary"
            size="lg"
            disabled={isLoading}
            className="w-full flex items-center justify-center"
          >
            <LogIn className="w-5 h-5 mr-2" />
            {isLoading ? 'Signing in...' : 'Sign in with Google'}
          </Button>
          
          <p className="mt-4 text-sm text-gray-500">
            By signing in, you agree to our Terms of Service and Privacy Policy
          </p>
        </div>
      </div>
    </div>
  );
};